import { Link, Typography } from '@mui/material';
import { Box, Card, Stack } from '@mui/material';
import Label from 'components/ui/info/Label';
import Spinner from 'components/ui/loadingIndicators/Spinner';
import Scrollbar from 'components/ui/Scrollbar';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import { format } from 'date-fns';
import useDI from 'hooks/useDI';
import useIsMobile from 'hooks/useIsMobile';
import useLocales from 'hooks/useLocales';
import useRequestHandler from 'hooks/useRequestHandler';
import React from 'react';
import ReleaseNoteUtils from 'utils/models/ReleaseNoteUtils';

function ReleaseNotesBlock() {
  const { apiService } = useDI();
  const { translate } = useLocales();
  const isMobile = useIsMobile();

  // Обернуто так, как не для ендпоинта не требуется авторизация
  const { state: releaseNoteList, isLoading } = useRequestHandler({
    initialValue: [] as ReleaseNote[],
    instantRequest: true,
    action: () => apiService.entity.get<ReleaseNote[]>(PATH_BACKEND.releaseNotes.root).then(ReleaseNoteUtils.sortByReleaseDate),
  });

  const notesContent = isLoading ? (
    <Spinner sx={{ m: 'auto' }} />
  ) : (
    <Stack spacing={2} pb={2}>
      {releaseNoteList.map((note, index) => (
        <ReleaseNoteListItem isNew={index === 0} releaseNote={note} key={note.title} />
      ))}
    </Stack>
  );

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Stack mb={{ xs: 2.5, md: 3.5 }} direction="row" justifyContent={{ xs: 'center', md: 'space-between' }} alignItems="center">
        <Typography variant="h4">{translate('pages.login.updates')}</Typography>
        {!isMobile && (
          <Link
            sx={{ mr: 2, display: { xs: 'hidden', md: 'block' } }}
            component={'a'}
            variant="subtitle2"
            target="_blank"
            href="https://confluence.marya.ru/pages/viewpage.action?pageId=36143874"
          >
            {translate('pages.login.showAll')}
          </Link>
        )}
      </Stack>

      <Scrollbar sx={{ height: { md: 592 }, pr: { xs: 0, md: 2 }, pb: { xs: 3, md: 0 } }}>{notesContent}</Scrollbar>
    </Box>
  );
}

function ReleaseNoteListItem({ releaseNote, isNew }: { releaseNote: ReleaseNote; isNew: boolean }) {
  const { releaseDate, href, title } = releaseNote;

  return (
    <Card
      sx={(theme) => ({
        py: 1.5,
        px: 2,
        '&:hover': { background: theme.palette.action.hover },
        transition: theme.transitions.create('background-color'),
        cursor: 'pointer',
      })}
      onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
    >
      <Box>
        <Box>
          <Typography fontWeight={500} variant="subtitle1">
            {title}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography color="text.secondary" variant="body2">
            {format(new Date(releaseDate), 'dd.MM.yyyy')}
          </Typography>
          {isNew && <Label color="primary">New</Label>}
        </Box>
      </Box>
    </Card>
  );
}

export default React.memo(ReleaseNotesBlock, () => true);
